import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=c977c1fc&scoped=true"
import script from "./workOrderDetail.vue?vue&type=script&lang=js"
export * from "./workOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=c977c1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c977c1fc",
  null
  
)

export default component.exports